module.exports = __webpack_public_path__ + "media/unipod/delivery-61bdee40.jpg";